module.exports = __webpack_public_path__ + "img/1596383773.2bf0af9a.jpg";